module.exports = __webpack_public_path__ + "img/learn2esport.67ad3d07.png";